import { KeySubjects } from 'civil-status/constants/keys-subjects-section';

export const keyChangeSpouseFromSubject = (
  keySubjectCurrent?: string,
  isCivilUnion?: boolean
): string => {
  if (!keySubjectCurrent) {
    return '';
  }

  if (isCivilUnion) {
    switch (keySubjectCurrent) {
      case KeySubjects.keyDeceduto:
        return KeySubjects.keyUnitoCivilmente;
      default:
        return '';
    }
  }

  switch (keySubjectCurrent) {
    case KeySubjects.keyDeceduto:
      return KeySubjects.keyConiuge;
    default:
      return '';
  }
};
